'use client';

// import Image from 'next/image';
import React from 'react';
import { useTranslations } from 'next-intl';
import { ContainerLG, useModal } from '..';
import { Button, withPlayfairO } from './StyleConstants';
import { CustomImage as Image } from '..';
import styles from './ColorCatalogueSection.module.css';
import { JwelXIcon } from 'assets/icons/JwelX';
import { CrossCircle } from 'assets/icons';

type ModalContentType = {
  title: React.ReactNode;
  image: string;
  subtitleKey: string;
  image2: string;
  descriptionKey: string;
  color: string;
  footerKey?: string;
};

const CatalogueData: ReadonlyArray<
  Record<string, string | ModalContentType | undefined | null>
> = [
  {
    title: 'Desert Rose',
    image: 'web_v2/rare/portrait-shots/dessert-rose.png',
    modalContent: {
      title: withPlayfairO('DESERT ROSE'),
      color: '#5D2F17',
      image: 'web_v2/rare/emerging-renders/dessert-rose.jpg',
      subtitleKey: 'ring.rare.catalogue.desertRose.subtitle',
      image2: 'web_v2/rare/elements-renders/dessert-rose.jpg',
      descriptionKey: 'ring.rare.catalogue.desertRose.description',
      footerKey: 'ring.rare.catalogue.desertRose.footer',
    },
  },
  {
    title: 'Desert Snow',
    image: 'web_v2/rare/portrait-shots/dessert-snow.png',
    modalContent: {
      title: withPlayfairO('DESERT SNOW'),
      color: '#0B152C',
      image: 'web_v2/rare/emerging-renders/dessert-snow.jpg',
      subtitleKey: 'ring.rare.catalogue.desertSnow.subtitle',
      image2: 'web_v2/rare/elements-renders/dessert-snow-v2.png',
      descriptionKey: 'ring.rare.catalogue.desertSnow.description',
      footerKey: 'ring.rare.catalogue.desertSnow.footer',
    },
  },
  {
    title: 'Dune',
    image: 'web_v2/rare/portrait-shots/dune.png',
    modalContent: {
      title: <>DUNE</>,
      color: '#4C190C',
      image: 'web_v2/rare/emerging-renders/dune.jpg',
      subtitleKey: 'ring.rare.catalogue.dune.subtitle',
      image2: 'web_v2/rare/elements-renders/dune.jpg',
      descriptionKey: 'ring.rare.catalogue.dune.description',
      footerKey: 'ring.rare.catalogue.dune.footer',
    },
  },
];

const ModalContentTemplate = (
  props: { className?: string } & ModalContentType,
) => {
  const ModalClient = useModal();
  const t = useTranslations('ring');
  const richTags = {
    br: () => <br />,
  };

  return (
    <div
      className={styles.modalContent}
      style={
        { ['--modal-bg']: props.color ?? '#000000' } as React.CSSProperties
      }
    >
        <h2>{props.title}</h2>
        <Image width="1800" height="940" src={props.image} alt={''} />
        {props.subtitleKey ? (
          <p className="subtitle">{withPlayfairO(t(props.subtitleKey))}</p>
        ) : null}
        {props.image2 ? (
          <Image
            width="1080"
            height="743"
            src={props.image2}
            alt={''}
            className="image-2"
          />
        ) : null}
        {props.descriptionKey ? (
          <p className="description">{t(props.descriptionKey)}</p>
        ) : null}

        <div className="modal-footer">
          <div className="trademark">
            <div className="auth-stamp-img">
              <Image
                width={88.5}
                height={88.5}
                src={'web_v2/rare/auth-stamp.png'}
                alt={'auth-stamp'}
                className="image-2"
              />
            </div>
          </div>
          {props.footerKey ? (
            <div className="">
              <p className="footer-description">
                {t.rich(props.footerKey, richTags)}
              </p>
            </div>
          ) : null}
          <div className="partner">
            <p className="text">{t('ring.rare.catalogue.inPartnershipWith')}</p>
            <JwelXIcon />
          </div>
        </div>

        <div
          style={{
            textAlign: 'center',
            position: 'absolute',
            top: '24px',
            right: '24px',
          }}
        >
          <button
            className="close-btn"
            onClick={() => {
              ModalClient.hide();
              ModalClient.set(null);
            }}
          >
            <CrossCircle />
          </button>
        </div>
      </div>
    );
};

export const ColorCatalogueSection = ({
  head,
  backgroundColor,
  descriptionAlignment,
}: {
  head?: string;
  backgroundColor?: string;
  descriptionAlignment?: string;
}) => {
  const ModalClient = useModal();
  const t = useTranslations('ring');

    const openModalWith = (component: React.ReactNode) => {
      ModalClient.set(component);
      ModalClient.setCloseButtonTheme('light');
      ModalClient.setCloseBtnHidden(true);
      ModalClient.show();
    };

    return (
      <section
        className={styles.root}
        style={{
          backgroundColor: backgroundColor ? backgroundColor : 'transparent',
        }}
      >
        <ContainerLG>
          {head ? <h2 className="head">{head} </h2> : null}
          {/* <Container> */}
          <p
            className="init-description"
            style={{
              textAlign: (descriptionAlignment as any) || 'left',
              maxWidth: descriptionAlignment === 'center' ? '52ch' : '48ch',
              margin: descriptionAlignment === 'center' ? '0 auto' : 'initial',
              paddingBottom:
                descriptionAlignment === 'center' ? '56px' : '16px',
            }}
          >
            {t('ring.rare.catalogue.description')}
          </p>
          <div className="content">
            {/* <H2Caption>RARE COLLECTION</H2Caption> */}
            <CardsContainer>
              {CatalogueData.map((data, index) => (
                <Card
                  key={index}
                  onClick={() =>
                    openModalWith(
                      <ModalContentTemplate
                        {...(data.modalContent as ModalContentType)}
                      />,
                    )
                  }
                  aria-hidden="true"
                >
                  <div className="img-container">
                    <Image
                      width="1080"
                      height="1424"
                      src={data.image as string}
                      alt={data.title as string}
                    />
                  </div>
                  <Button
                    style={{
                      fontWeight: '500',
                    }}
                  >
                    {data.title as string}
                  </Button>
                </Card>
              ))}
            </CardsContainer>
          </div>
        </ContainerLG>
        {/* </Container> */}
      </section>
    );
};

const CardsContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={`${styles.cardsContainer} u-hide-scrollbar${
      className ? ` ${className}` : ""
    }`}
    {...props}
  />
);

const Card = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={`${styles.card}${className ? ` ${className}` : ""}`}
    {...props}
  />
);
